import { Button, FlexContainer } from '@act/storybook';
import { Typography } from '@mui/material';
import { NavLink } from 'react-router-dom';
import { useReportsPermissions } from '../hooks/useReportsPermissions.hook';

const NAV_ITEMS = [
  { to: '/', label: 'Reports', exact: true },
  { to: '/templates', label: 'Templates', exact: false },
  { to: '/library', label: 'Library', exact: false },
  { to: '/customers', label: 'Customer settings', exact: false },
] as const;

const REPORTS_CONTENT_MAX_WIDTH = '1152px';

/**
 * Top navigation for the reports subdomain layout.
 */
const ReportsNav = () => {
  const { canManageCustomers } = useReportsPermissions();

  return (
    <FlexContainer
      direction="column"
      width="100%"
      height="auto"
      overflowAllVisible={true}
      backgroundColor="#ffffff"
      border="1px solid rgba(0, 0, 0, 0.08)"
      padding={0}
    >
      <FlexContainer
        direction="column"
        width="100%"
        maxWidth={REPORTS_CONTENT_MAX_WIDTH}
        margin="0 auto"
        padding={2}
        gap={1.5}
        height="auto"
        overflowAllVisible={true}
      >
        <FlexContainer
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
          height="auto"
          overflowAllVisible={true}
          gap={2}
          flexWrap={true}
        >
          <FlexContainer
            direction="column"
            gap={0.25}
            height="auto"
            overflowAllVisible={true}
          >
            <Typography variant="h6" component="span">
              Customer Reports
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Internal — Reema Health
            </Typography>
          </FlexContainer>
        </FlexContainer>
        <FlexContainer
          direction="row"
          alignItems="center"
          gap={0.5}
          flexWrap={true}
          height="auto"
          overflowAllVisible={true}
        >
          {NAV_ITEMS.map(item => {
            if (item.to === '/customers' && !canManageCustomers) {
              return null;
            }
            return (
              <NavLink key={item.to} to={item.to} end={item.exact}>
                {({ isActive }) => (
                  <Button
                    variant={isActive ? 'contained' : 'text'}
                    size="small"
                    trackingName={`reports-nav-${item.label.toLowerCase()}`}
                  >
                    {item.label}
                  </Button>
                )}
              </NavLink>
            );
          })}
        </FlexContainer>
      </FlexContainer>
    </FlexContainer>
  );
};

export default ReportsNav;
